module.exports = __webpack_public_path__ + "static/media/icon-arrow-down-black.0e786905.svg";